import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';

import configData from '../../utils/config/config.json';
import { Context } from '../../services/apiContext';
import { useNotificationActionsContext } from '../../components/notificationModal/useModal';
import { useSearchParams } from 'react-router-dom';
import { getClientIp } from '../../helperFunctions/helperFunctions';
import Progressbar from '../Profile/Progressbar';
import BasicDetails from './BasicDetails';
import zerodha from '../../assets/Demat/zerodha-1.svg';
import Axis from '../../assets/Demat/Axis.svg';
import iifl1 from '../../assets/Demat/IIFL-Securities-Horizontal-PNG.png';
import Kotak from '../../assets/Demat/Kotak.png';
import ventura from '../../assets/Demat/ventura.jpg';
import Bajaj from '../../assets/Demat/Bajaj.png';
import religare from '../../assets/Demat/Religare.svg';
import icici1 from '../../assets/Demat/icici1.svg';
import BrokerList from './BrokerList';
import HDFC from '../../assets/Demat/HDFC.png';
import Marwadi from '../../assets/Demat/Marwadi.png';

import {
  useGlobalSpinnerActionsContext,
  useGlobalSpinnerContext,
} from '../../components/loader/useloader';
import AddGSTModal from './AddGSTModal';
import SummaryCounterArea from '../SummaryPages/SummaryCounterArea';
import SummaryTable, { BackButton } from '../SummaryPages/SummaryTable';

const FRONTEND_URL = window.location.origin;

const ReferGuest = (props) => {
  const contextapi = useContext(Context);

  const [step, setstep] = useState();
  const setNotifi = useNotificationActionsContext();

  const [step2Valid, setStep2Valid] = useState(true);
  const [disableAll, setDisableAll] = useState(false);
  const [showTable, setShowTable] = useState(false)

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const [showGSTModal, setShowGSTModal] = useState({
    value: false,
    parameters: {},
    newOpen: false,
  });

  const [basicDetails, setbasicDetails] = useState({
    name: '',
    email: '',
    mobile: '',
    pan: '',
    gst_flag: 'N',
    gst: '',
    referral_id: '',
  });

  useEffect(() => {
    getProfile();
  }, []);

  const getProfile = async () => {
    let referralRegistrationResponse = await getReferralRegistration();
    if (
      referralRegistrationResponse.data.status_code === '00' &&
      referralRegistrationResponse.data.referral_id !== null
    ) {
      setbasicDetails({
        mobile: referralRegistrationResponse.data.mobile,
        name: referralRegistrationResponse.data.name,
        email: referralRegistrationResponse.data.email,
        pan: referralRegistrationResponse.data.pan,
        gst_flag: referralRegistrationResponse.data.gst_flag,
        gst: referralRegistrationResponse.data.gst,
        referral_id: referralRegistrationResponse.data.referral_id,
      });
      createAllReferralLink(referralRegistrationResponse.data.referral_id);
      setDisableAll(true);
      setStep2Valid(true);
    } else {
      var userData = contextapi.getSession('userData_refer');
      setbasicDetails({
        ...basicDetails,
        mobile: userData.mobile,
      });
      setStep2Valid(false);
      setstep(1);
    }
  };

  const getReferralRegistration = async () => {
    var userData = contextapi.getSession('userData_refer');
    let newData = {};

    newData.user_key = userData.user_key;
    newData.mobile = userData.mobile;
    newData.user_ip = await getClientIp();

    var getData = {
      data: newData,
      url: configData.baseURLDev + '/referral/getRegistration',
    };

    var url = configData.baseURLProxy;

    let response;
    await contextapi
      .postApiAuthCalling(url, getData, false)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });
    return response;
  };

  const [brokersList, setBrokerList] = useState({

    IIFL: {
      name: 'IIFL',
      image: iifl1,
      link: FRONTEND_URL + '/signIn?refid=', 
      reward: 400,

    },

    
    // Marwadi: {
    //   name: 'Marwadi',
    //   image: Marwadi,
    //   link: FRONTEND_URL + '/signIn?refid=',
    //   reward: 300,
    // },

    Religare: {
      name: 'Religare',
      image: religare,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 350,
    },

    'Bajaj Finserv': {
      name: 'Bajaj Finserv',
      image: Bajaj,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 275,
    },

    'HDFC Securities': {
      name: 'HDFC Securities',
      image: HDFC,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 225,
    },
    'KOTAK Securities': {
      name: 'KOTAK Securities',
      image: Kotak,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 200,
    },
    'ICICI Securities': {
      name: 'ICICI Securities',
      image: icici1,
      link: FRONTEND_URL + '/signIn?refid=',     
      reward: 200,

    },
    Zerodha: {
      name: 'Zerodha',
      image: zerodha,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 25,
    },
    'Axis Securities': {
      name: 'Axis Securities',
      image: Axis,
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 200,
    },
    // 'Ventura Securities': {
    //   name: 'Ventura Securities',
    //   image: ventura,
    //   link: FRONTEND_URL + '/signIn?refid=',
    //   reward: 400,
    // },

    // IIFL: {
    //   name: 'IIFL',
    //   image: iifl1,
    //   link: FRONTEND_URL + '/signIn?refid=',      reward: 275,

    // },


    '': {
      name: '',
      image: '',
      link: FRONTEND_URL + '/signIn?refid=',
      reward: 275,
    },
  });

  const handleInputData = (input, value) => {
    //updating for data state taking previous state and then adding new value to create new object
    setbasicDetails((prevState) => ({
      ...prevState,
      [input]: value,
    }));
  };

  const StepClick = (stepNo) => {
    setstep(stepNo);
  };

  const createAllReferralLink = async (referral = basicDetails.referral_id) => {
    Object.keys(brokersList).forEach(async (brokerName) => {
      let referralResponse = await createReferralLink({
        referral_id: referral,
        broker_name: brokerName,
      });

      if (referralResponse.status_code === '00') {
        brokersList[brokerName].link =
          brokersList[brokerName].link +
          (referralResponse.transaction_id ?? '');
        setBrokerList({ ...brokersList });
      }
    });
    setGlobalSpinner(false);
    setDisableAll(true);
    setstep(2);
  };

  const updateGST = () => {
    setShowGSTModal({ ...showGSTModal, value: true, newOpen: false });
  };

  const clickListen = async (action, gst_flag, gst) => {
    console.log(action, gst_flag, gst);
    setShowGSTModal({ ...showGSTModal, value: false, newOpen: true });
    if (action === 'editGST') {
      let updateGSTResponse = await updateReferralGST({ gst_flag, gst });

      if (updateGSTResponse.status_code === '00') {
        setbasicDetails({
          ...basicDetails,
          gst: gst,
          gst_flag: gst_flag,
        });
        setNotifi({ val: true, msg: 'GST Updated Successfully' });
      } else {
        setNotifi({ val: true, msg: 'GST could not be updated' });
      }
    }
  };

  const updateReferralGST = async (data) => {
    let url = '/referral/gstUpdate';
    var userData = contextapi.getSession('userData_refer');
    let newData = {};

    newData.user_key = userData.user_key;
    newData.referral_id = basicDetails.referral_id;
    newData.gst_flag = data.gst_flag;
    if (data.gst_flag === 'Y') newData.gst = data.gst;
    newData.user_ip = await getClientIp();

    let postData = newData;

    console.log(postData);

    let response;
    await contextapi
      .postApiAuthCalling(url, postData, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });

    return response;
  };

  const createReferralLink = async (data) => {
    var url = '/referral/createReferral';
    var userData = contextapi.getSession('userData');
    let newData = {};

    newData.user_key = userData.user_key;
    newData.referral_id = data.referral_id;
    newData.transaction_id = data.transaction_id;
    newData.broker_name = data.broker_name;

    newData.source_id = 'kfin';
    newData.utm_source = 'kfin';
    newData.utm_medium = 'web';
    newData.utm_camp = 'kfincamp';
    newData.utm_camp_id = 'camp1';
    newData.user_ip = await getClientIp();

    var postobjt = newData;
    let response;
    await contextapi
      .postApiAuthCalling(url, postobjt, true)
      .then((res) => {
        response = res;
      })
      .catch((error) => {
        response = error;
      });
    return response;
  };

  const renderReferDetails = () => {
    switch (step) {
      case 1:
        return (
          <BasicDetails
            basicDetails={basicDetails}
            handleFormData={handleInputData}
            createAllReferralLink={createAllReferralLink}
            disableAll={disableAll}
            setstep={setstep}
            setStep2Valid={setStep2Valid}
          ></BasicDetails>
        );
      case 2:
        return (<>

          {!showTable ? 
              <SummaryCounterArea 
                  referral_id={basicDetails.referral_id}
                  onButtonClicked={(i)=>setShowTable(i)}
              />
              :
              <SummaryTable 
                  referral_id={basicDetails.referral_id}
                  type={showTable}
              />
          }
        
          <div className='col-md-12 form-divNew d-flex justify-content-around pt-0'>
              {!showTable && step2Valid && <BrokerList brokersList={brokersList}></BrokerList>}
          </div>
        </>
        );
      default:
        return <></>;
    }
  };
  return (
    <>
      <div className='container mx-auto mt-5 px-0 leftsidebox'>
        <div className='row mx-0'>
          <div className='headerdiv'>
            <div className='userProfileHeader d-flex justify-content-between'>
              IPO Referral
              {


              
              step === 2 && 
              <Fragment>
                {!!showTable ? 
                    <BackButton 
                      onClick={()=>setShowTable(0)}
                    />
                    :
                  <div className='headerBtn'>
                    <button
                      type='button'
                      name='button'
                      className='  btncolor small-btn'
                      style={{ paddingLeft: 20, paddingRight: 20 }}
                      onClick={() => updateGST()}
                    >
                      Add/Edit GST
                    </button>
                  </div>
                }
              </Fragment>
              }
            </div>

            <div className='progressbarinendline'>
              <Progressbar
                bgcolor='#374488'
                progress={step === 1 ? 50 : 100}
                height={5}
              />
            </div>
          </div>
          <div className='innerDiv'>
            <div className='row makerel'>
              <div className='col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings'>
                <button
                  type='button'
                  className={
                    step === 1
                      ? 'customdesign w-15 activeState'
                      : 'customdesign w-15'
                  }
                  onClick={() => StepClick(1)}
                >
                  <p>Basic Details</p>{' '}
                </button>
              </div>

              <div className='col-lg-2 col-md-3 col-sm-4 col-xs-4 col-4 paddings'>
                <button
                  type='button'
                  className={
                    step === 2
                      ? 'customdesign w-15 activeState'
                      : 'customdesign w-15'
                  }
                  disabled={!step2Valid}
                  onClick={() => StepClick(2)}
                >
                  <p>Select Broker</p>{' '}
                </button>
              </div>
              <div className='underline'></div>
            </div>
                  
            <div className="mt-4">
              {renderReferDetails()}
            </div>

            {showGSTModal.value && (
              <AddGSTModal
                openstatus={showGSTModal.value}
                defaultValue={{
                  gst_flag: basicDetails.gst_flag,
                  gst: basicDetails.gst,
                  newOpen: showGSTModal.newOpen,
                }}
                title={'Update GST'}
                clickListen={clickListen}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReferGuest;
